const ACTIVE_KEY = 'installer_active_tasks';

const pickWo = (...values) => {
    for (const value of values) {
        const match = String(value || '').match(/WO\d+/i);
        if (match) {
            return match[0].toUpperCase();
        }
    }
    return null;
};

export const buildInstallerSmsCodes = ({
    externalId,
    ttNumber,
    smsCodes
} = {}) => {
    if (smsCodes?.accept || smsCodes?.wo) {
        const wo = smsCodes.wo || pickWo(smsCodes.accept);
        const t2wo = smsCodes.t2wo || (wo ? `T2${wo}` : null);
        return {
            wo,
            t2wo,
            accept: smsCodes.accept || (wo ? `#107*${wo}#` : null),
            cancel: smsCodes.cancel || (wo ? `#107*0*${wo}#` : null),
            arrive:
                smsCodes.arrive ||
                (t2wo ? `#102*${t2wo}#` : null)
        };
    }

    const wo = pickWo(externalId, ttNumber);
    if (!wo) {
        return {
            wo: null,
            t2wo: null,
            accept: null,
            cancel: null,
            arrive: null
        };
    }

    const t2wo = `T2${wo}`;
    return {
        wo,
        t2wo,
        accept: `#107*${wo}#`,
        cancel: `#107*0*${wo}#`,
        arrive: `#102*${t2wo}#`
    };
};

export const smsTextForAction = (action, codes) => {
    if (!codes) return null;
    if (action === 'accept') return codes.accept;
    if (action === 'on_site') return codes.arrive;
    if (action === 'cancel') return codes.cancel;
    return null;
};

const readActive = () => {
    try {
        const raw = JSON.parse(
            localStorage.getItem(ACTIVE_KEY) || '[]'
        );
        return Array.isArray(raw) ? raw : [];
    } catch (_) {
        return [];
    }
};

const writeActive = rows => {
    localStorage.setItem(ACTIVE_KEY, JSON.stringify(rows));
    if (typeof window !== 'undefined') {
        window.dispatchEvent(
            new CustomEvent('installer-active-tasks', {
                detail: rows
            })
        );
    }
};

const isActiveStatus = status => {
    const s = String(status || '')
        .trim()
        .toLowerCase()
        .replace(/ё/g, 'е');
    return [
        'принято исполнителем',
        'в дороге на объект',
        'на объекте'
    ].includes(s);
};

export const rememberActiveTask = task => {
    if (!task?.id) return;
    const rows = readActive().filter(
        row => Number(row.id) !== Number(task.id)
    );
    rows.unshift({
        id: task.id,
        title: task.title || task.ttNumber || `Заявка ${task.id}`,
        ttNumber: task.ttNumber || null,
        status: task.status || null
    });
    writeActive(rows.slice(0, 20));
};

export const forgetActiveTask = taskId => {
    writeActive(
        readActive().filter(
            row => Number(row.id) !== Number(taskId)
        )
    );
};

export const syncActiveTasksFromList = tasks => {
    const next = (tasks || [])
        .filter(task => task?.id && isActiveStatus(task.status))
        .map(task => ({
            id: task.id,
            title:
                task.title ||
                task.ttNumber ||
                `Заявка ${task.id}`,
            ttNumber: task.ttNumber || null,
            status: task.status || null
        }));
    writeActive(next);
};

export const listActiveTasks = () => readActive();
